import { render, staticRenderFns } from "./143.vue?vue&type=template&id=6ca709f8&scoped=true&"
var script = {}
import style0 from "./143.vue?vue&type=style&index=0&id=6ca709f8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ca709f8",
  null
  
)

export default component.exports